module.exports = __webpack_public_path__ + "img/33-02.48dd7d1f.png";